import _export from "../internals/export";
import _functionCall from "../internals/function-call";
import _anObject from "../internals/an-object";
import _getIteratorDirect from "../internals/get-iterator-direct";
import _notANan from "../internals/not-a-nan";
import _toPositiveInteger from "../internals/to-positive-integer";
import _iteratorCreateProxy from "../internals/iterator-create-proxy";
import _iteratorClose from "../internals/iterator-close";
import _isPure from "../internals/is-pure";
var $ = _export;
var call = _functionCall;
var anObject = _anObject;
var getIteratorDirect = _getIteratorDirect;
var notANaN = _notANan;
var toPositiveInteger = _toPositiveInteger;
var createIteratorProxy = _iteratorCreateProxy;
var iteratorClose = _iteratorClose;
var IS_PURE = _isPure;
var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  if (!this.remaining--) {
    this.done = true;
    return iteratorClose(iterator, "normal", undefined);
  }
  var result = anObject(call(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return result.value;
});

// `Iterator.prototype.take` method
// https://tc39.es/ecma262/#sec-iterator.prototype.take
$({
  target: "Iterator",
  proto: true,
  real: true,
  forced: IS_PURE
}, {
  take: function take(limit) {
    anObject(this);
    var remaining = toPositiveInteger(notANaN(+limit));
    return new IteratorProxy(getIteratorDirect(this), {
      remaining: remaining
    });
  }
});
export default {};